import { Fonts } from 'components/typography/text'
import styled from 'styled-components'

export const ContentWrapper = styled.div<{ isBuying: boolean }>`
  width: 295px;
  background-color: ${({ theme }) => theme.widgetBgColor};
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: flex;
  flex-direction: column;
  min-height: 357px;
  position: relative;
`
export const ContentAndAccordionWrapper = styled.div<{
  connected: boolean
  correctNetwork: boolean
}>`
  position: relative;
  height: 100%;
  width: 100%;
  height: 360px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    display: flex;
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    display: flex;
    justify-content: center;
  `}
`

export const WidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.bg};
  margin-top: 35px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 0;
  `}
`

export const WidgetFooterWrapper = styled.div``

export const WidgetBodyWrapper = styled.div``

export const TabWrapper = styled.div``

export const WidgetVisibleWrapper = styled.div`
  width: 100%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 295px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: ${({ theme }) => theme.widgetBgColor};
  * {
    font-family: ${Fonts.DMSans};
  }
`
